import type { WizardStepProps } from '../../../../types/builder.types'



export function MapConfiguration({ config, onChange, onNext, onPrev }: WizardStepProps) {


  

  // Get fields from dynamic data sources or fallback to static
  

  

  

  

  const mapConfig = config.mapConfig || {}

  const isValid = Boolean(
    config.metadata?.title 
    //mapConfig.latitudeKey &&
    //mapConfig.longitudeKey &&
    //mapConfig.nameKey
  )

  return (
    <div className="max-w-3xl mx-auto">
      <button onClick={onPrev} className="mb-6 text-green-600 hover:underline">
        ← Volver
      </button>

      <h2 className="text-2xl font-bold mb-2">Configurar Mapa Interactivo</h2>
      <p className="text-gray-600 mb-6">
        Define los campos de datos que se mostrarán en el mapa
      </p>

      <div className="space-y-6 bg-white border rounded-lg p-6">
        {/* Título del componente */}
        <div>
          <label className="block font-medium mb-2">
            Título del Mapa <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="Ej: Municipios Forestales de Palencia"
            className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            value={config.metadata?.title || ''}
            onChange={(e) =>
              onChange({
                ...config,
                metadata: { ...config.metadata, title: e.target.value },
              })
            }
          />
        </div>

        {/* Campo de Latitud */}
        {/*<div>
          <label className="block font-medium mb-2">
            Campo de Latitud <span className="text-red-500">*</span>
          </label>
          <select
            className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            value={mapConfig.latitudeKey || ''}
            onChange={(e) =>
              onChange({
                ...config,
                mapConfig: { ...mapConfig, latitudeKey: e.target.value },
              })
            }
          >
            <option value="">Selecciona un campo...</option>
            {numericFields.map((field) => (
              <option key={field.name} value={field.name}>
                {field.label}
              </option>
            ))}
          </select>
          <p className="text-sm text-gray-500 mt-1">
            Campo numérico con coordenadas de latitud (ej: 42.0095)
          </p>
        </div>

        
        <div>
          <label className="block font-medium mb-2">
            Campo de Longitud <span className="text-red-500">*</span>
          </label>
          <select
            className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            value={mapConfig.longitudeKey || ''}
            onChange={(e) =>
              onChange({
                ...config,
                mapConfig: { ...mapConfig, longitudeKey: e.target.value },
              })
            }
          >
            <option value="">Selecciona un campo...</option>
            {numericFields.map((field) => (
              <option key={field.name} value={field.name}>
                {field.label}
              </option>
            ))}
          </select>
          <p className="text-sm text-gray-500 mt-1">
            Campo numérico con coordenadas de longitud (ej: -4.5275)
          </p>
        </div>

        
        <div>
          <label className="block font-medium mb-2">
            Campo de Nombre <span className="text-red-500">*</span>
          </label>
          <select
            className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            value={mapConfig.nameKey || ''}
            onChange={(e) =>
              onChange({
                ...config,
                mapConfig: { ...mapConfig, nameKey: e.target.value },
              })
            }
          >
            <option value="">Selecciona un campo...</option>
            {textFields.map((field) => (
              <option key={field.name} value={field.name}>
                {field.label}
              </option>
            ))}
          </select>
          <p className="text-sm text-gray-500 mt-1">
            Nombre que aparecerá en cada marcador del mapa
          </p>
        </div>

        
        <div>
          <label className="block font-medium mb-2">
            Campo de Valor (opcional)
          </label>
          <select
            className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            value={mapConfig.valueKey || ''}
            onChange={(e) =>
              onChange({
                ...config,
                mapConfig: { ...mapConfig, valueKey: e.target.value || undefined },
              })
            }
          >
            <option value="">Ninguno</option>
            {numericFields.filter(f => f.aggregatable).map((field) => (
              <option key={field.name} value={field.name}>
                {field.label}
              </option>
            ))}
          </select>
          <p className="text-sm text-gray-500 mt-1">
            Valor numérico para colorear los marcadores según intensidad
          </p>
        </div>

        
        <div>
          <label className="block font-medium mb-2">Tipo de Mapa</label>
          <div className="grid grid-cols-3 gap-3">
            {[
              { value: 'markers', label: 'Marcadores', icon: '📍' },
              { value: 'heatmap', label: 'Calor', icon: '🔥' },
              { value: 'choropleth', label: 'Coroplético', icon: '🗺️' },
            ].map((type) => (
              <button
                key={type.value}
                type="button"
                className={`
                  border-2 rounded p-3 text-center transition-all
                  ${
                    (mapConfig.mapType || 'markers') === type.value
                      ? 'border-green-500 bg-green-50'
                      : 'border-gray-200 hover:border-green-300'
                  }
                `}
                onClick={() =>
                  onChange({
                    ...config,
                    mapConfig: { ...mapConfig, mapType: type.value as any },
                  })
                }
              >
                <div className="text-2xl mb-1">{type.icon}</div>
                <div className="text-sm font-medium">{type.label}</div>
              </button>
            ))}
          </div>
        </div>*/}

        {/* Configuración del Centro y Zoom */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="font-semibold text-blue-900 mb-3">Configuración Inicial del Mapa</h3>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="block text-sm font-medium mb-1">Latitud Centro</label>
              <input
                type="number"
                step="0.0001"
                placeholder="42.0095"
                className="w-full border rounded px-3 py-2 text-sm"
                value={mapConfig.centerLat || ''}
                onChange={(e) =>
                  onChange({
                    ...config,
                    mapConfig: { ...mapConfig, centerLat: parseFloat(e.target.value) || undefined },
                  })
                }
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Longitud Centro</label>
              <input
                type="number"
                step="0.0001"
                placeholder="-4.5275"
                className="w-full border rounded px-3 py-2 text-sm"
                value={mapConfig.centerLon || ''}
                onChange={(e) =>
                  onChange({
                    ...config,
                    mapConfig: { ...mapConfig, centerLon: parseFloat(e.target.value) || undefined },
                  })
                }
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Zoom Inicial</label>
              <input
                type="number"
                min="1"
                max="18"
                placeholder="8"
                className="w-full border rounded px-3 py-2 text-sm"
                value={mapConfig.zoom || ''}
                onChange={(e) =>
                  onChange({
                    ...config,
                    mapConfig: { ...mapConfig, zoom: parseInt(e.target.value) || undefined },
                  })
                }
              />
            </div>
          </div>
          <p className="text-sm text-blue-700 mt-2">
            💡 Deja en blanco para centrado automático basado en los datos
          </p>
        </div>
      </div>

      <div className="flex gap-4 mt-6">
        <button
          onClick={onPrev}
          className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-300"
        >
          ← Atrás
        </button>
        <button
          onClick={onNext}
          disabled={!isValid}
          className="flex-1 bg-green-600 text-white py-3 rounded-lg font-medium hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Vista Previa →
        </button>
      </div>
    </div>
  )
}
